import { render, staticRenderFns } from "./ShareScreener.vue?vue&type=template&id=0637faf4&"
import script from "./ShareScreener.vue?vue&type=script&lang=js&"
export * from "./ShareScreener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports